import { render, staticRenderFns } from "./PkgOptCvrList.vue?vue&type=template&id=45fc895f&"
import script from "./PkgOptCvrList.vue?vue&type=script&lang=js&"
export * from "./PkgOptCvrList.vue?vue&type=script&lang=js&"
import style0 from "./PkgOptCvrList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PkgOptCvrList.vue"
export default component.exports